import axios from 'axios'
import { API_URL } from '../../config/apiConfig';
import { combineEpics, Epic } from 'redux-observable'
import { catchError, filter, map, mergeMap, startWith, switchMap } from 'rxjs/operators'
import {
  addedCardspartners,
  addingCardspartners,
  addingCardspartnersFailed,
  CardspartnersAction,
  CardspartnersActionTypes,
  editedCardspartners,
  editingCardspartners,
  editingCardspartnersFailed,
  foundCardspartners,
  loadedCardspartners,
  loadingCardspartners,
  loadingCardspartnersFailed,
  removedCardpartners,
  removingCardpartners,
  removingCardpartnersFailed,
  searchingCardspartners,
  searchingCardspartnersFailed,
  softRemovedCardspartners,
  softRemovingCardspartners,
  softRemovingCardspartnersFailed,
} from '../actions/cardspartnersActions'
import buildFormData from './buildFormData'

import { from, of } from 'rxjs'
import { isOfType } from 'typesafe-actions'
import { IState } from '../reducers'


const searchCardspartnersEpic: Epic<CardspartnersAction, CardspartnersAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardspartnersActionTypes.SEARCH_CARDSPARTNERS)),
    mergeMap((action) => {
      if (typeof action.searchOptions === 'string') {
        action.searchOptions = {
          searchString: action.searchOptions,
          page: 1,
          searchField: '_id',
        }
      }
      let url = `${API_URL}/api/cardspartners/search/`
      return from(axios.get(url, { params: action.searchOptions })).pipe(
        map((response) => foundCardspartners(response.data, action.keep)),
        startWith(searchingCardspartners()),
        catchError(() => of(searchingCardspartnersFailed()))
      )
    })
  )

const loadCardspartnersEpic: Epic<CardspartnersAction, CardspartnersAction, IState> = (action$, state$) => {
  let responses = []
  return action$.pipe(
    filter(isOfType(CardspartnersActionTypes.LOAD_CARDSPARTNERS)),
    switchMap((action) => {
      let url = `${API_URL}/api/cardspartners/`
      return from(axios.get(url, { params: action.loadOptions })).pipe(
        map((response) => loadedCardspartners(response.data)),
        startWith(loadingCardspartners()),
        catchError(() => of(loadingCardspartnersFailed()))
      )
    })
  )
}

const addCardspartnersEpic: Epic<CardspartnersAction, CardspartnersAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardspartnersActionTypes.ADD_CARDSPARTNERS)),

    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.post(`${API_URL}/api/cardspartners/`, data, config)).pipe(
        map((response) => addedCardspartners(response.data)),
        startWith(addingCardspartners()),
        catchError((err) => of(addingCardspartnersFailed(err.response)))
      )
    })
  )

const removeCardspartnersEpic: Epic<CardspartnersAction, CardspartnersAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardspartnersActionTypes.REMOVE_CARDPARTNERS)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/cardspartners/${action.payload._id}`)).pipe(
        map((response) => removedCardpartners()),
        startWith(removingCardpartners()),
        catchError(() => of(removingCardpartnersFailed()))
      )
    )
  )

const softRemoveCardspartnersEpic: Epic<CardspartnersAction, CardspartnersAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardspartnersActionTypes.SOFT_REMOVE_CARDSPARTNERS)),
    mergeMap((action) =>
      from(axios.delete(`${API_URL}/api/cardspartners/soft/${action.payload._id}`)).pipe(
        map((response) => softRemovedCardspartners(response.data.record)),
        startWith(softRemovingCardspartners()),
        catchError((err) => of(softRemovingCardspartnersFailed(err.response)))
      )
    )
  )

const editCardspartnersEpic: Epic<CardspartnersAction, CardspartnersAction, IState> = (action$, state$) =>
  action$.pipe(
    filter(isOfType(CardspartnersActionTypes.EDIT_CARDSPARTNERS)),
    mergeMap((action) => {
      const data = new FormData()
      buildFormData(data, action.payload)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
        },
      }

      return from(axios.put(`${API_URL}/api/cardspartners/${action.payload._id}`, data, config)).pipe(
        map((response) => editedCardspartners(response.data)),
        startWith(editingCardspartners()),
        catchError((err) => of(editingCardspartnersFailed(err.response)))
      )
    })
  )

export default combineEpics(
  searchCardspartnersEpic,
  loadCardspartnersEpic,
  addCardspartnersEpic,
  removeCardspartnersEpic,
  softRemoveCardspartnersEpic,
  editCardspartnersEpic
)
